import {IComponentOptions, ILogService} from "angular";

class StudentApplicationFooterController {
    /* @ngInject */
    constructor(private $log: ILogService) {
    }
}

export const StudentApplicationFooterComponent: IComponentOptions = {
    bindings: {
        application: "<",
        actionsDisabled: "<",
        onSaveAsDraft: "&",
        onSubmit: "&"
    },
    controller: StudentApplicationFooterController,
    template: require("./student-application-footer.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/student/application/footer/student-application-footer.component.ts